import React, { useContext, useEffect, useState } from "react";

import { useLocation,Link, useNavigate } from "react-router-dom";
import requestUser from "../../services/requestUser";
import { apiUser } from "../../services/api";
import { AppContext } from "../../services/context";
// import FormNotify from "../componentsmedicsoft/FormNotify";

const Reset = () => {
  const authCtx = useContext(AppContext);
  const { user, onUserChange } = authCtx;
  const navigate = useNavigate();
  const [inputType, setInputType] = useState("password");
  const [loginFail, setLoginFail] = useState(false);
  const [email, setEmail] = useState({
    email: "",
  });
  const [isSend,setIsSend] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
  };

  

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoginFail(false);
    requestUser
        .post('http://localhost:8081/api/activation', email)
        
        .then((res) => {

          // isAuth();
          navigate("/verification", { state: { email: email.email } });      
        })
        .catch((error) => {
          setLoginFail(true);
          console.log(error);
        });
  };

  const onChange = (e) => {
    setEmail({
      ...email,
      [e.target.name]: e.target.value, // Met à jour la clé correspondant au champ
    });
  };


 
 
  return (
    <>
    <div className="container-fluid d-flex justify-content-center align-items-center" 
         style={{ minHeight: "100vh", backgroundColor: "#f0f0f0" }}>
      <div className="row w-100" 
           style={{ maxWidth: "900px", backgroundColor: "#fff", borderRadius: "15px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        
        {/* Left Side: Form */}
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center" style={{ padding: "30px" }}>
          <div className="w-100">
            <img src={require('../.././assets/imgs/logo_pnud.png')} alt="Logo" 
                 style={{ maxWidth: "120px", display: "block", margin: "0 auto" }} />
            <h3 className="text-center">We are The Lotus Team</h3>
            <p className="text-center">Veuillez entrer votre adresse mail de reinitialisation</p>
  
            <form onSubmit={handleSubmit} className="w-100">
              {loginFail ? (
                <div className="mb-3">
                  {/* <FormNotify
                    bg={"danger"}
                    title={""}
                    message={"Votre code est incorrect, veuillez entrer le code à nouveau."}
                  /> */}
                </div>
              ) : null}
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                  name="email"
                  value={email.email}
                  onChange={onChange}
                />
                <label htmlFor="floatingInput">Email</label>
              </div>
             
              <button className="btn btn-primary w-100 mb-3" type="submit" 
                      style={{ background: "linear-gradient(to right, #007bff, #00d2ff)" }}>
                Envoyer l'adresse mail de reinitialisation...
              </button>
             
            </form>
  
        
          </div>
        </div>
  
        {/* Right Side: Branding & Message */}
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center" 
             style={{ background: "linear-gradient(to right, #0d4e88, #27d2fd)", color: "#fff", padding: "30px", 
                      borderTopRightRadius: "15px", borderBottomRightRadius: "15px" }}>
          <div className="text-center">
            <h2>We are more than just a company</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
  
  
  
  

  );
};

export default Reset;
